// @flow

import * as React from 'react';
import AutoComplete from 'react-autocomplete';
import Theme from '../../themes';

const { borderRadius } = Theme.global;
const { borderColor, placeholderColor, errorBorderColor } = Theme.forms.inputs;

const defaultRenderItem = (value: string) => (item: Object) => {
  const itemLabelParsed = Array.prototype.map.call(item.label, (labelChar, index) => {
    if (!value || !labelChar || labelChar.trim() === '') {
      return labelChar;
    }

    if (
      typeof value[index] !== 'undefined' &&
      value[index].toLowerCase() === labelChar.toLowerCase()
    ) {
      return labelChar;
    }

    return <strong key={`${index}-${labelChar}`}>{labelChar}</strong>;
  });

  return (
    <div className="menuItem" key={item.value}>
      {itemLabelParsed}
      <style jsx>
        {`
          .menuItem {
            padding: 0.8em;
            font-size: 14px;
            border-bottom: 1px solid ${borderColor};
          }
          .menuItem:last-child {
            border-bottom: none;
          }
        `}
      </style>
    </div>
  );
};

type Props = {
  field: ?string,
  items: Array<?Object>,
  wrapperStyle: ?Object,
  renderItem: (value: string) => (item: Object) => Object,
  onChange: Function,
  onSelect: ?Function,
  onFocus: ?Function,
  value: ?string,
  placeholder: ?string,
  style: Object,
};

class AutoCompleteInput extends React.PureComponent<Props> {
  static defaultProps = {
    field: 'what_d',
    style: null,
    placeholder: null,
    wrapperStyle: {
      width: '100%',
      position: 'relative',
      zIndex: '3',
      marginBottom: '0',
    },
    renderItem: defaultRenderItem,
    onSelect: null,
    onFocus: null,
  };

  render() {
    const {
      field,
      value,
      wrapperStyle,
      renderItem,
      onChange,
      onSelect,
      onFocus,
      placeholder,
      items,
      style,
    } = this.props;
    const styleCustom = {
      ...style,
      borderRadius: `${borderRadius}`,
      width: '100%',
    };

    const showMenu = items && items.length > 0 ? { display: 'block' } : { display: 'none' };

    return (
      <div>
        <AutoComplete
          inputProps={{ id: field, placeholder, style: styleCustom, onFocus }}
          value={value}
          onChange={onChange}
          onSelect={onSelect}
          wrapperStyle={wrapperStyle}
          renderMenu={children => (
            <div className="menu" style={showMenu}>
              {children}
            </div>
          )}
          getItemValue={item => item.value}
          items={items}
          renderItem={renderItem(value || '')}
        />
        <style jsx>
          {`
            :global(input::placeholder) {
              color: ${placeholderColor};
            }
            :global(input.error::placeholder) {
              color: ${errorBorderColor};
            }
            input.error {
              border-color: ${errorBorderColor};
            }
            .menu {
              border: 1px solid ${borderColor};
              background-color: #fff;
              margin-top: -1px;
              border-radius: ${borderRadius};
              position: absolute;
              width: 100%;
            }
          `}
        </style>
      </div>
    );
  }
}

export default AutoCompleteInput;



// WEBPACK FOOTER //
// ./app/common/forms/AutoCompleteInput.js